
<div class="container grow flex-column center gap-l">
    
    <mat-spinner diameter=" 64"></mat-spinner>
    <div id="autologin"  (click)="login($event)" class=" mat-h2">You need to be logged in to view requested page. Please log in to continue</div>

</div>
